<style scoped>
.app-body {
    flex: 1 0 auto;
}

.floating-cart {
    position: fixed;
    top: 50vh;
    right: 0;
    transform: translateY(-50%);
    z-index: 10;
}

/* calc(75rem + 4rem * 2) */
@media all and (min-width: 83rem) {
    .floating-cart {
        right: calc((100vw - 75rem) / 2 - 4rem);
    }
    .floating-cart::v-deep.cart-expand {
        right: 0;
    }
}

/* calc(75rem + (4rem + 14rem) * 2) */
@media all and (min-width: 111rem) {
    .floating-cart::v-deep.cart-expand {
        right: calc((100vw - 75rem) / 2 - 14rem - 4rem);
    }
}
</style>
<template>
    <div
        id="app"
        class="font-sans flex flex-col min-h-screen sm:h-screen text-darkGrayishBlue"
        v-on-interaction="keepMarketingEventHandlerAlive"
    >
        <Header
            class="flex-shrink-0 sticky sm:block top-0 sm:top-auto z-20 bg-white"
        />

        <div ref="body" class="flex-1 flex flex-col">
            <div
                v-if="isPreviewShoppingListByShopListKey"
                class="flex-shrink-0 w-full max-w-site mx-auto border-b-2 border-t-0 sm:border-l-2 sm:border-r-2 sm:rounded-b-lg border-secondary p-1"
            >
                {{
                    shoppingList
                        ? `${shoppingList.shopListName}  (${formatDate(
                              shoppingList.saleBgnDate,
                              'fulldate'
                          )} - ${formatDate(
                              shoppingList.saleEndDate,
                              'fulldate'
                          )})`
                        : ''
                }}
            </div>
            <TimeoutBannerWithGreet
                v-if="$route.meta.showTimeoutBannerWithGreet === true"
                class="flex-shrink-0 w-full max-w-site mx-auto border-b-2 border-t-0 sm:border-l-2 sm:border-r-2 sm:rounded-b-lg border-secondary"
            />
            <div
                class="w-full app-body relative flex flex-col-reverse sm:flex-col"
            >
                <div
                    class="sm:flex sm:flex-row w-full max-w-site mx-auto mb-auto sm:mb-0"
                >
                    <main class="sm:flex-1">
                        <router-view class="px-4 pb-16" />
                    </main>
                    <aside
                        class="app-aside sm:w-1/4 mb-4 sm:my-0"
                        v-if="$route.meta.showAd !== false && false"
                    >
                        <div class="sm:sticky sm:top-0" v-sticky>
                            <Advertisement />
                        </div>
                    </aside>
                </div>
                <facebookPagePlugin v-if="$route.meta.showAd !== false" />
            </div>
            <Footer class="flex-shrink-0" />
        </div>
        <floatingAdvertisement v-if="$route.meta.showFloatingAdvrt === true" />
        <loginVideoAdvertisement />
        <!-- <collapsibleCart
            class="floating-cart "
            v-if="$route.meta.showFloatingCart === true"
        /> -->
        <floatingCartAlert v-if="$route.meta.showFloatingCart === true" />
        <askLoginRegisterModal
            :showModal="showLoginRegisterModal"
            @hide="showLoginRegisterModal = false"
        />
        <popupAdvertisementModal
            :advrt="popupAdvertisement"
            @hide="popupAdvertisement = undefined"
        />
        <verifyPhoneNumberModal v-if="showConfirmPhoneNumberModal">
            <div class="flex flex-col my-4">
                <div class="ml-auto">
                    <router-link
                        to="/logout"
                        tag="button"
                        class="text-blue hover:text-black underline"
                    >
                        {{ $t('login.logout') }}
                    </router-link>
                </div>
                <div class="flex">
                    <div class="mr-4">
                        {{
                            phoneNumber
                                ? '您的手機號碼是 ' + phoneNumber
                                : '您尚未輸入手機號碼'
                        }}
                    </div>
                    <router-link
                        class="text-blue hover:text-black underline"
                        :to="{
                            name: 'accountInfo'
                        }"
                        @click.native="
                            $store.commit('setShowConfirmPhoneNumber', false)
                        "
                    >
                        {{ $t('account.change.phone') }}
                    </router-link>
                </div>
            </div>
        </verifyPhoneNumberModal>
    </div>
</template>

<script>
import '../../assets/css/tailwind.css';
import Header from '../../components/header.vue';
import TimeoutBannerWithGreet from '../../components/timeoutBannerWithGreet.vue';
import Footer from '../../components/footer.vue';
import Advertisement from '../../components/advertisement.vue';
import askLoginRegisterModal from '../../components/askLoginRegisterModal.vue';
import popupAdvertisementModal from '../../components/popupAdvertisementModal.vue';
import sticky from '../../directives/stickyDirective';
import onInteraction from '../../directives/onInteraction';
import { marketingEventHandler } from '../../utils/marketingDataProcessor.js';
// import collapsibleCart from '../../components/collapsibleCart.vue';
import floatingCartAlert from '../../components/floatingCartAlert.vue';
import floatingAdvertisement from '../../components/floatingAdvertisement.vue';
import verifyPhoneNumberModal from '../../components/verifyPhoneNumberModal.vue';
import facebookPagePlugin from '../../components/facebookPagePlugin.vue';
import formatDate from '../../components/formatDateFilter';
import loginVideoAdvertisement from '../../components/loginVideoAdvertisement.vue';

export default {
    components: {
        Header,
        TimeoutBannerWithGreet,
        Footer,
        Advertisement,
        askLoginRegisterModal,
        popupAdvertisementModal,
        // collapsibleCart,
        floatingCartAlert,
        floatingAdvertisement,
        verifyPhoneNumberModal,
        facebookPagePlugin,
        loginVideoAdvertisement
    },
    directives: { sticky, onInteraction },
    computed: {
        showLoginRegisterModal: {
            get: function() {
                return this.$store.state.showLoginRegisterModal;
            },
            set: function(newVal) {
                this.$store.commit('setShowLoginRegisterModal', newVal);
            }
        },
        popupAdvertisement: {
            get: function() {
                return this.$store.state.popupAdvertisement;
            },
            set: function(advrt) {
                this.$store.commit('setPopupAdvertisement', advrt);
            }
        },
        requireConfirmTermsOfUse() {
            return this.$store.getters.requireConfirmTermsOfUse;
        },
        requireConfirmPhoneNumber() {
            return this.$store.getters.requireConfirmPhoneNumber;
        },
        showConfirmPhoneNumberModal() {
            return (
                this.requireConfirmPhoneNumber &&
                this.$route.name &&
                (this.$route.name !== 'accountInfo' ||
                    this.$store.state.showConfirmPhoneNumber === true)
            );
        },
        phoneNumber() {
            return this.$store.state.user?.custPhoneNum;
        },
        shoppingList() {
            return this.$store.getters.shoppingList;
        },
        isPreviewShoppingListByShopListKey() {
            return this.$store.getters.isPreviewShoppingListByShopListKey;
        }
    },
    created() {
        this.formatDate = formatDate;
        this.$watch(
            'requireConfirmTermsOfUse',
            function(v) {
                if (v) {
                    this.$router.push('/confirmTermsOfUse');
                }
            },
            {
                immediate: true
            }
        );
    },
    methods: {
        keepMarketingEventHandlerAlive: () => {
            marketingEventHandler.keepAlive();
        }
    }
};
</script>
